export default "<div [ngStyle]=\"{'background': selectedBackground}\" class=\"landing-page\">\n    <app-login></app-login>\n</div>"